import calculateCouponValue from "../../moneyBuilder/investments/objects/calculate_coupon_value";
import ConfigFile from "../../../datasets/config_file";
import buildHistoryTransactionObj from "../../moneyBuilder/investments/objects/build_history_transaction_obj";

export const checkForPayoutTrans = (transactionArr, maturityDateArr, investmentMaster, beginTransNbr,
    currentGameDate, monthNbr) => {
    
    let faceValue = ConfigFile.investments.bondFaceValue;
    let bondMatured = false;
    let transNbr = beginTransNbr;
    let historyArr = [];
    let buyTransDeleteArr = [];
        
    for (let i=0; i<transactionArr.length; i++){
        const transaction = transactionArr[i];
        const maturityDateObj = maturityDateArr.find(elem => elem.investShortName === transaction.investShortName);
        const maturityDate = maturityDateObj.maturityDate;
        const investMaster = investmentMaster.find(elem => elem.investShortName === transaction.investShortName);
    
        // determine if bond has reached date of maturity
        if (currentGameDate >= maturityDate && transaction.tranType === "buy"){
            if (investMaster.bondInfo && investMaster.bondInfo.faceValue){
                faceValue = investMaster.bondInfo.faceValue;
            }
            const redemptionValue = faceValue.toFixed(2);
            const buyAmount = (+transaction.unitPrice * +transaction.quantity).toFixed(2);
            const sellAmount = +redemptionValue * +transaction.quantity;
            const gainLoss = +sellAmount - +buyAmount;
            transNbr += 1;
            const tranInfo = {investShortName: transaction.investShortName, tranType: "buy-redemption",
                            quantity: transaction.quantity, dateClosed: currentGameDate, 
                            dateBought: transaction.transactionDate, buyPrice: transaction.unitPrice, 
                            buyAmount: buyAmount,
                            sellPrice: redemptionValue, sellAmount: sellAmount, totalGainLoss: gainLoss,
                            transNbr: transNbr, investmentName: investMaster.investmentName}
            const transactionObj = buildHistoryTransactionObj(tranInfo);
            historyArr.push(transactionObj);
            bondMatured = true;
            buyTransDeleteArr.push(i);  //  keep array of buyTrans that can be deleted
        }
        //  determine if a coupon is due
        if (investMaster.bondInfo.coupon === true){
            let payCoupon = false;
            const bondInfo = investMaster.bondInfo;
            if (investMaster.classification === "Treasury Bond"){
                const month = currentGameDate.split("-")[1];
                if (month === "06" || month === "12"){
                    payCoupon = true;
                }
            }else{
                const remainder = +monthNbr % +bondInfo.couponFrequency;
                if (remainder === 0){
                    payCoupon = true;
                }
            }
            if (payCoupon === true || bondMatured === true){
                let couponPayOut = calculateCouponValue(bondInfo, currentGameDate, 
                    transaction.transactionDate, "game", transaction.investShortName, 
                    investMaster.classification);
                const sellAmount = +couponPayOut.sellPrice * +transaction.quantity;
                transNbr +=1;
                const tranInfo = {...couponPayOut, quantity: transaction.quantity,  
                            sellPrice: couponPayOut.sellPrice, sellAmount: sellAmount, totalGainLoss: sellAmount,
                            transNbr: transNbr, investmentName: investMaster.investmentName}
                const transactionObj = buildHistoryTransactionObj(tranInfo);
                historyArr.push(transactionObj);
            }
        }
    }
    const maxIndx = buyTransDeleteArr.length - 1;
    for (let i=maxIndx; i>=0; i--){
        const indx = buyTransDeleteArr[i];
        transactionArr.splice(indx,1);
    }
    return historyArr;
}
    
export default checkForPayoutTrans;